import { Divider } from '@mui/material'
import { Fragment } from 'react'

import { BookingListItemLoading } from './common'

export const BookingListLoading = () => {
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <Fragment key={index}>
          <BookingListItemLoading />
          {index < 2 && <Divider />}
        </Fragment>
      ))}
    </>
  )
}
